export default __webpack_public_path__ + "static/media/boat.ee34728a.svg";